enum occupationActionTypeKeys {
  OCCUPATION_TITLE_SERVICE_LIST_REQUESTED = 'OCCUPATION_TITLE_SERVICE_LIST_REQUESTED',
  OCCUPATION_TITLE_LIST_REQUEST_SUCCEEDED = 'OCCUPATION_TITLE_LIST_REQUEST_SUCCEEDED',
  OCCUPATION_TITLE_SERVICE_LIST_REQUEST_FAILED = 'OCCUPATION_TITLE_SERVICE_LIST_REQUEST_FAILED',
  OCCUPATION_TITLE_SERVICE_LIST_RESET = 'OCCUPATION_TITLE_SERVICE_LIST_RESET',
}

export default occupationActionTypeKeys;
